<template>
  <form class="form">
    <div class="mb-3">
      <label for="email" class="form-label">
        {{ $store.state.language.emailAddress }}
      </label>
      <input type="email" class="form-control" id="email" v-model="email" />
    </div>

    <div class="text-end mt-5">
      <button
        v-if="emailIsCorrect"
        type="submit"
        class="btn btn-main-dark"
        @click="forgotpassword"
      >
        {{ $store.state.language.send }}
      </button>
      <button v-else type="submit" class="btn btn-main-dark disabled" disabled>
        {{ $store.state.language.send }}
      </button>

      <router-link :to="{ name: 'Signin' }" custom v-slot="{ navigate }">
        <span
          role="link"
          @click="navigate"
          class="btn ms-3"
          @keypress.enter="navigate"
        >
          {{ $store.state.language.signin }}
        </span>
      </router-link>
    </div>
  </form>
</template>

<script>
export default {
  name: "ForgotPassword",

  data() {
    return {
      email: "",
      emailIsCorrect: false,
    };
  },

  watch: {
    email() {
      const val = this.$store.state.utils.filters.validateEmail(this.email);
      this.emailIsCorrect = val;
    },
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {
    forgotpassword() {
      event.preventDefault();
      if (this.emailIsCorrect) {
        this.$store.state.utils.processing = true;

        this.$store.state.modules.api
          .forgotpassword(this.email)
          .then((resp) => {
            this.email = "";
            if (resp.status === 200) {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "success",
                  message: "Bestätigungs-E-Mail wurde geschickt.",
                },
                2500
              );

              this.$router.push({ name: "LandingPage" });
            } else {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "warning",
                  title: "Fehlermeldung",
                  message: "Etwas ist schief gelaufen. :(",
                },
                2500
              );
            }
            this.$store.state.utils.processing = false;
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            title: "Fehlermeldung",
            message: "Die E-Mail ist falsch!",
          },
          2500
        );
        this.$store.state.utils.processing = false;
      }
    },
  },
};
</script>
